import {Button, Col, Radio, Row, Space, Typography, Input, Form} from "antd";
import React, {useEffect, useState} from "react";
import Icons from "assets/icons";
import {DataInputField, InputFields} from "components/common";
import "./ExtraocularExpand.scss";
import {
  FieldsExtraocular1,
  FieldsExtraocular2,
  fieldsTropiaLeft,
  fieldsTropiaRight,
  fieldsHorizontalLeft,
  fieldsHorizontalRight,
  fieldsVerticalLeft,
  fieldsVerticalRight,
  fieldsParalyticLeft,
  fieldsParalyticRight,
  fieldsETLeft,
  fieldsETRight,
  fieldsXTLeft,
  fieldsXTRight,
  fieldsPhoriaRight,
  fieldsPhoriaLeft,
} from "./ExtraocularExpand.config";
import {useAppSelector} from "redux/hooks";

type Props = {
  isOpen: boolean;
  setIsOpen: () => void;
  index: number;
};

const ExtraocularExpand: React.FC<Props> = ({isOpen, setIsOpen, index}) => {
  const dataChanDoan = useAppSelector(state => state.examination.dataChanDoan);
  const [squint, setSquint] = useState<"Lác hiện" | "Lác ẩn" | " ">(" ");
  const [tropia, setTropia] = useState<
    "Chiều ngang" | "Chiều dọc" | "Lác liệt" | " "
  >(" ");
  const [horizontal, setHorizontal] = useState<"Lác trong" | "Lác ngoài" | " ">(
    " "
  );
  const [data, setData] = useState(null);
  useEffect(() => {
    if (index == 0) {
      FieldsExtraocular1.find(e => e.label == "Lác").onChange = e => {
        setSquint(e.target.value);
      };
      fieldsTropiaRight[0].onChange = e => {
        setTropia(e.target.value);
      };
      fieldsHorizontalRight[0].onChange = e => {
        setHorizontal(e.target.value);
      };
    }
    if (index == 1) {
      FieldsExtraocular2.find(e => e.label == "Lác").onChange = e => {
        setSquint(e.target.value);
      };
      fieldsTropiaLeft[0].onChange = e => {
        setTropia(e.target.value);
      };
      fieldsHorizontalLeft[0].onChange = e => {
        setHorizontal(e.target.value);
      };
    }
  }, []);
  useEffect(() => {
    if (dataChanDoan) {
      const formValue = JSON.parse(dataChanDoan?.jsonValue);
      if (index == 0) {
        setData(formValue?.rightJsonValue?.EXTRAOCULAR_MOVEMENTS_SQUINT);
      }
      if (index == 1) {
        setData(formValue?.leftJsonValue?.EXTRAOCULAR_MOVEMENTS_SQUINT);
      }
    }
  }, [dataChanDoan]);
  useEffect(() => {
    if (data) {
      setSquint(data["Lác"]);
      setTropia(data["Lác hiện"]);
      setHorizontal(data["Chiều ngang"]);
    }
  }, [data]);
  const objectChanDoan = useAppSelector(
    state => state.examination.objectChanDoan
  );
  const ref = useAppSelector(state => state.examination.ref);
  useEffect(() => {
    if (!isOpen) {
      // const fieldsValue = ref.getChanDoanValue();
      if (ref) {
        ref.setFieldValue(
          [
            `${index == 1 ? "leftJsonValue" : "rightJsonValue"}`,
            "EXTRAOCULAR_MOVEMENTS_SQUINT",
          ],
          null
        );
      }
    }
    if (ref) {
      ref.setFieldValue(
        [
          `${index == 1 ? "leftJsonValue" : "rightJsonValue"}`,
          "EXTRAOCULAR_MOVEMENTS_SQUINT",
          "show",
        ],
        isOpen
      );
    }
  }, [isOpen, ref]);
  useEffect(() => {
    if (objectChanDoan && ref) {
      const show = ref.getFieldValue([
        `${index == 1 ? "leftJsonValue" : "rightJsonValue"}`,
        "EXTRAOCULAR_MOVEMENTS_SQUINT",
        "show",
      ]);
      if (Boolean(show) == true && isOpen == false) {
        setIsOpen();
      }
      if (Boolean(show) == false && isOpen == true) {
        setIsOpen();
      }
    }
  }, [objectChanDoan, ref]);
  return (
    <Space
      direction="vertical"
      className="space-common space-extraocular"
      size={"middle"}
    >
      <Row justify={"start"} className="row-common">
        <Button
          type="primary"
          icon={isOpen ? <Icons.sub rev={0} /> : <Icons.add rev={0} />}
          onClick={setIsOpen}
        />
        <Typography className="title-common-healthy">
          VẬN NHÃN VÀ LÁC
        </Typography>
      </Row>

      {isOpen ? (
        <div>
          <Row gutter={[16, 8]}>
            <InputFields
              data={index === 0 ? FieldsExtraocular1 : FieldsExtraocular2}
            />
            {squint == "Lác hiện" && (
              <>
                <InputFields
                  data={index == 0 ? fieldsTropiaRight : fieldsTropiaLeft}
                ></InputFields>
                {tropia == "Chiều ngang" && (
                  <>
                    <InputFields
                      data={
                        index == 0
                          ? fieldsHorizontalRight
                          : fieldsHorizontalLeft
                      }
                    ></InputFields>
                    {horizontal == "Lác trong" && (
                      <InputFields
                        data={index == 0 ? fieldsETRight : fieldsETLeft}
                      ></InputFields>
                    )}
                    {horizontal == "Lác ngoài" && (
                      <InputFields
                        data={index == 0 ? fieldsXTRight : fieldsXTLeft}
                      ></InputFields>
                    )}
                  </>
                )}
                {tropia == "Chiều dọc" && (
                  <>
                    <InputFields
                      data={
                        index == 0 ? fieldsVerticalRight : fieldsVerticalLeft
                      }
                    ></InputFields>
                  </>
                )}
                {tropia == "Lác liệt" && (
                  <>
                    <InputFields
                      data={
                        index == 0 ? fieldsParalyticRight : fieldsParalyticLeft
                      }
                    ></InputFields>
                  </>
                )}
              </>
            )}
            {squint == "Lác ẩn" && (
              <InputFields
                data={index == 0 ? fieldsPhoriaRight : fieldsPhoriaLeft}
              ></InputFields>
            )}
          </Row>
        </div>
      ) : null}
    </Space>
  );
};

export default ExtraocularExpand;
